import { render } from "./FloatingCartButton.vue?vue&type=template&id=3d5c1d90&scoped=true"
import script from "./FloatingCartButton.vue?vue&type=script&lang=js"
export * from "./FloatingCartButton.vue?vue&type=script&lang=js"

import "./FloatingCartButton.vue?vue&type=style&index=0&id=3d5c1d90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5c1d90"]])

export default __exports__